const columnIcon = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.54031 1.53659H2.56096C1.99521 1.53659 1.53658 1.99522 1.53658 2.56098V18.439C1.53658 19.0048 1.99521 19.4634 2.56096 19.4634H6.54031V1.53659ZM2.56096 0C1.14658 0 0 1.14659 0 2.56098V18.439C0 19.8534 1.14658 21 2.56096 21H8.07689V0H2.56096Z"
      fill="#6B00DF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.0017 1.53659H7.99801V19.4634H13.0017V1.53659ZM6.46143 0V21H14.5383V0H6.46143Z"
      fill="#6B00DF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.439 1.53659H14.4597V19.4634H18.439C19.0048 19.4634 19.4634 19.0048 19.4634 18.439V2.56098C19.4634 1.99522 19.0048 1.53659 18.439 1.53659ZM12.9231 0V21H18.439C19.8534 21 21 19.8534 21 18.439V2.56098C21 1.14659 19.8534 0 18.439 0H12.9231Z"
      fill="#6B00DF"
    />
  </svg>
);

export default columnIcon;
